import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const BASE = process.env.REACT_APP_API_URL || '';

export default function TrocarSenhaInicial() {
  const { token, clearMustChangePassword } = useAuth();
  const navigate = useNavigate();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');

    if (novaSenha.length < 6) {
      setErro('A senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmacao) {
      setErro('As senhas não coincidem.');
      return;
    }

    setCarregando(true);
    try {
      await axios.post(
        `${BASE}/configuracoes/trocar-senha-inicial/`,
        { nova_senha: novaSenha },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      clearMustChangePassword();
      navigate('/dashboard', { replace: true });
    } catch (err) {
      const detalhe = err.response?.data?.nova_senha?.[0]
        || err.response?.data?.detail
        || 'Erro ao trocar a senha. Tente novamente.';
      setErro(detalhe);
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white rounded-lg shadow p-8 w-full max-w-sm">
        <h1 className="text-xl font-semibold text-gray-800 mb-1">Troca de senha obrigatória</h1>
        <p className="text-sm text-gray-500 mb-6">
          Esta é a senha temporária do primeiro acesso. Defina uma senha pessoal para continuar.
        </p>

        {erro && (
          <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
            {erro}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nova senha</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
              value={novaSenha}
              onChange={e => setNovaSenha(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar nova senha</label>
            <input
              type="password"
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
              value={confirmacao}
              onChange={e => setConfirmacao(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={carregando}
            className="w-full bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white font-medium py-2 rounded text-sm"
          >
            {carregando ? 'Salvando...' : 'Definir senha e entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
